import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

interface University {
    name: string;
    image: string;
}

export const useUniversities = () => {
    return useQuery<University[]>({
        queryKey: ["universities"],
        queryFn: async () => {
            const { data } = await axiosClient.get("/universities",{ withCredentials: true });
            return data;
        },
    });
};
